import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { CircleLoader, TextArea } from 'common-src/components/base';
import { Colors } from 'common-src/styles';
import { MAX_SMS_MESSAGE_LENGTH } from 'common-src/utils/validationUtils';

import Icons from 'src/assets/Icons';
import { ModalType } from 'src/components/base/ModalGroup';
import { openModal } from 'src/features/modals';

import styles from './SendSmsInput.module.scss';

const SendSmsInput = ({
  patientId,
  phoneNumber,
  text,
  onTextChange,
  error,
  isLoading,
  onSmsSendClick,
}) => {
  const dispatch = useDispatch();

  const isDisabled = !phoneNumber || isLoading || text.length === 0 || !!error;

  return (
    <div className={styles.container}>
      <TextArea
        id="send-sms-input"
        classNames={[styles.inputContainer, 'm-b-16']}
        inputClassNames={[styles.input, error ? styles.error : '']}
        fixedRows={3}
        onTextChange={onTextChange}
        value={text}
        placeholder="SMS text"
        maxLength={MAX_SMS_MESSAGE_LENGTH}
        description={`Used characters: ${text.length}/${MAX_SMS_MESSAGE_LENGTH}`}
        withError={!!error}
        errorText={error}
        size="small"
        disabled={!phoneNumber || isLoading}
      />
      <div className={styles.buttonContainer}>
        <p
          className={[styles.sendButton, isDisabled ? styles.disabled : ''].join(' ')}
          role="presentation"
          onClick={() => {
            if (!isDisabled) {
              onSmsSendClick?.();
            }
          }}
        >
          {!isLoading && <img className={styles.icon} src={Icons.sendIcon} alt="send-sms-icon" />}
          {isLoading && <CircleLoader color={Colors.white} strokeWidth={2} circleRadius={9} />}
        </p>
        <div
          className={[styles.scheduleButton, isDisabled ? styles.disabled : ''].join(' ')}
          role="presentation"
          onClick={() =>
            dispatch(openModal(ModalType.SCHEDULE_SMS_MESSAGE, { patientId, phoneNumber }))
          }
        >
          {isLoading ? (
            <CircleLoader color={Colors.white} strokeWidth={2} circleRadius={9} />
          ) : (
            <img className={styles.icon} src={Icons.calendarPlusIcon} alt="schedule-sms-icon" />
          )}
        </div>
      </div>
    </div>
  );
};

SendSmsInput.propTypes = {
  patientId: PropTypes.number,
  phoneNumber: PropTypes.string,
  text: PropTypes.string,
  onTextChange: PropTypes.func,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  onSmsSendClick: PropTypes.func,
};

export default SendSmsInput;
